import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Tools|Duplicate Email Queue';

export type SPDuplicateEmailQueueLocNames = 'SPDuplicateEmailQueueTotalDuplicateEmails';

export const spDuplicateEmailQueueLocs: LocDefs<SPDuplicateEmailQueueLocNames> = {
	SPDuplicateEmailQueueTotalDuplicateEmails: {
		defaultValue: 'Total duplicate emails: ',
		description: 'Total duplicate emails message',
		displayPath: `${dpRoot}|Total Duplicate Emails`,
		displayType: 'Content',
		shared: false,
		htmlAllowed: false,
		feature: HubFeature.Tools,
		portal: 'SP',
	},
};

export const LOC_KEYS = MapLocKeys<SPDuplicateEmailQueueLocNames>(spDuplicateEmailQueueLocs);
export type SPDuplicateEmailQueueLocType = LocMap<SPDuplicateEmailQueueLocNames>;
